var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 130,
    viewBox: "0 0 343 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_224_7055)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M0 104.901H60.092V126.908H85.4003V104.901H100.927V83.6882H85.4003V1.71143H52.2672L0 84.0549V104.901ZM60.5811 83.6882H26.6532V82.71L59.6029 30.5653H60.5811V83.6882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M171.095 129.659C202.577 129.659 221.589 105.696 221.65 64.432C221.711 23.4744 202.455 0 171.095 0C139.674 0 120.601 23.4132 120.54 64.432C120.417 105.574 139.551 129.598 171.095 129.659ZM171.095 107.713C156.729 107.713 147.437 93.2862 147.498 64.432C147.559 36.0062 156.79 21.7016 171.095 21.7016C185.338 21.7016 194.63 36.0062 194.63 64.432C194.691 93.2862 185.4 107.713 171.095 107.713Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M242.073 104.901H302.165V126.908H327.474V104.901H343.001V83.6882H327.474V1.71143H294.34L242.073 84.0549V104.901ZM302.654 83.6882H268.726V82.71L301.676 30.5653H302.654V83.6882Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_7055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 129.659,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.a9a0f9f2dfe0f5c98f936b30df8d5c38.svg";
export { ForwardRef as ReactComponent };